import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';

import { EventTypes } from 'src/app/core/constants/event-types';
import { PaginatedListOfGetPhonebookRecipientByScheduledMessageIdDto } from '../../../../core/api/models/paginated-list-of-get-phonebook-recipient-by-scheduled-message-id-dto';
import { OutBoxMessagesService } from '../../../../core/api/services/out-box-messages.service';
import { TranslationService } from '../../../../i18n/translation.service';
import { BaseIndexPageComponent } from '../../../shared/base/components/base-index-page.component';
import { GetOutBoxByScheduledIdDto } from './../../../../core/api/models/get-out-box-by-scheduled-id-dto';

@Component({
  selector: 'app-outbox-messages-send-smart-detail',
  templateUrl: './outbox-messages-send-smart-detail.component.html',
  standalone: false,
})
export class OutboxMessagesSendSmartDetailComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageVocabs = 'pages.outboxMessages.detail.';
  fields = 'pages.outboxMessages.fields.';

  @Input() model: GetOutBoxByScheduledIdDto;
  @Input() scheduledMessageId: number;
  @Input() isShowSmartSmsRecipient: boolean = true;

  @Output('closePage') output_closPage = new EventEmitter<boolean>();

  //#endregion

  constructor(
    public translationService: TranslationService,
    protected currentService: OutBoxMessagesService
  ) {
    super();
  }

  ngOnInit() {
    try {
      this.getEnumsValues();
      this.configTableColumns();
      this.initTablePagination();
      this.configPage();
      this.pageConfig.tableConfig.hidePagination = true;
      this.pageConfig.tableConfig.showTableShadow = false;
      this.pageConfig.tableConfig.showDeleteFilters = false;
      this.pageConfig.tableConfig.showOperationColumn = false;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  //#region init

  getVocabs() {}
  // getTableData(){}

  configTableColumns() {
    this.tableColumns = [
      {
        title: 'common.title',
        name: 'title',
        noSorting: true,
      },
      {
        title: 'common.persianPrice',
        name: 'persianPrice',
        type: 'number',
        noSorting: true,
      },
      {
        title: 'common.englishPrice',
        name: 'englishPrice',
        type: 'number',
        noSorting: true,
      },
      {
        title: 'common.fromIndex',
        name: 'fromIndex',
        type: 'number',
        noSorting: true,
      },
      { title: 'common.count', name: 'count', type: 'number', noSorting: true },
      {
        title: 'common.startDateTime',
        name: 'startDateTime',
        type: 'dateTime',
        noSorting: true,
      },
      {
        title: 'common.endDateTime',
        name: 'endDateTime',
        type: 'dateTime',
        noSorting: true,
      },
    ];
  }

  //#endregion

  //#region Api

  //Get All
  getPaginationApi(): Observable<PaginatedListOfGetPhonebookRecipientByScheduledMessageIdDto> {
    return;
  }

  geDetailById(ScheduledMessageId: number) {
    this.unSubs();
    this.loading = true;
    this.currentService
      .outBoxMessagesGetOutboxMessageByScheduledMessageId({
        scheduledMessageId: ScheduledMessageId,
      })
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        if (res) this.model = res.data;
      });
  }

  //#endregion

  onClose() {
    this.output_closPage.emit(true);
  }

  onRefresh() {
    if (this.loading) return;
    this.geDetailById(this.scheduledMessageId);
  }

  unSubs() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
